__turbopack_context__.v({
  "product-header": "ProductCardHeader-module-scss-module__zsZ4QW__product-header",
  "product-header__content": "ProductCardHeader-module-scss-module__zsZ4QW__product-header__content",
  "product-header__detail": "ProductCardHeader-module-scss-module__zsZ4QW__product-header__detail",
  "product-header__heading": "ProductCardHeader-module-scss-module__zsZ4QW__product-header__heading",
  "product-header__image": "ProductCardHeader-module-scss-module__zsZ4QW__product-header__image",
  "product-header__logo": "ProductCardHeader-module-scss-module__zsZ4QW__product-header__logo",
  "product-header__price": "ProductCardHeader-module-scss-module__zsZ4QW__product-header__price",
  "product-header__price-info": "ProductCardHeader-module-scss-module__zsZ4QW__product-header__price-info",
  "product-header__tagline": "ProductCardHeader-module-scss-module__zsZ4QW__product-header__tagline",
});
